export default __webpack_public_path__ + "files/8a9816ae9c0cd846ae780433ccb979f0.jpg";